/*
  Loom Collection: keep bulbs in step with their lamp in the cart (Symmetry 8, Oct 2026).
  Bulbs added with a lamp are shown inside the lamp's cart line (snippets/cart-item.liquid) and have a
  hidden quantity input (.loom-bundle-qty) with the bulbs-per-lamp ratio. The theme's cart code sends
  every .cart-item__quantity-input to /cart/update.js, so we only need to set the bulb values whenever
  the lamp's quantity is changed or the lamp is removed.
*/
(() => {
  const sync = (item) => {
    if (!item) return;
    const subs = item.querySelectorAll('.loom-bundle-qty');
    if (!subs.length) return;
    const main = item.querySelector('.cart-item__quantity-input:not(.loom-bundle-qty)');
    if (!main) return;
    const qty = Math.max(parseInt(main.value, 10) || 0, 0);
    subs.forEach((input) => {
      const ratio = parseFloat(input.dataset.ratio) || 1;
      input.value = Math.max(Math.round(qty * ratio), 0);
    });
  };

  // The theme handles these on the cart form first (it updates the lamp's input), then we follow.
  document.addEventListener('click', (evt) => {
    const control = evt.target.closest('.quantity-down, .quantity-up, .cart-item__remove');
    if (control) sync(control.closest('.cart-item'));
  });
  document.addEventListener('change', (evt) => {
    if (evt.target.matches('.cart-item__quantity-input:not(.loom-bundle-qty)')) {
      sync(evt.target.closest('.cart-item'));
    }
  });
  // Cart page without JavaScript updates: make sure values are right before the form is sent.
  document.addEventListener('submit', (evt) => {
    evt.target.querySelectorAll?.('.cart-item').forEach(sync);
  }, true);
})();
